"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./stylesheet.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Section = function Section(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      headerTitle = _ref.headerTitle,
      headerText = _ref.headerText,
      footerTitle = _ref.footerTitle,
      footerActions = _ref.footerActions,
      rest = _objectWithoutProperties(_ref, ["children", "className", "headerTitle", "headerText", "footerTitle", "footerActions"]);

  var Header = (0, _react.useCallback)(function () {
    if (headerTitle || headerText) {
      return _react.default.createElement("header", {
        className: "b-section__header"
      }, headerTitle && _react.default.createElement("h2", null, headerTitle), headerText && _react.default.createElement("p", null, headerText));
    }

    ;
    return null;
  }, [headerTitle, headerText]);
  var FooterActions = (0, _react.useCallback)(function () {
    if (footerActions && footerActions.length > 0) {
      return _react.default.createElement("ul", {
        className: "u-list-horizontal u-list-horizontal--center"
      }, footerActions.map(function (i, k) {
        return _react.default.createElement("li", {
          key: "section-footer-action-".concat(k)
        }, i);
      }));
    }

    ;
    return null;
  }, [footerActions]);
  var Footer = (0, _react.useCallback)(function () {
    if (footerTitle || footerActions) {
      return _react.default.createElement("footer", {
        className: "b-section__footer"
      }, footerTitle && _react.default.createElement("h3", null, footerTitle), _react.default.createElement(FooterActions, null));
    }

    ;
    return null;
  }, [footerTitle, footerActions]);
  return _react.default.createElement("section", _extends({
    className: "b-section ".concat(className)
  }, rest), _react.default.createElement(Header, null), children, _react.default.createElement(Footer, null));
};

Section.propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  headerTitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  headerText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  footerTitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  footerActions: _propTypes.default.array
};
var _default = Section;
exports.default = _default;